/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./language-menu.vue?vue&type=template&id=829a4bea&scoped=true&"
import script from "./language-menu.vue?vue&type=script&lang=js&"
export * from "./language-menu.vue?vue&type=script&lang=js&"
import style0 from "./language-menu.vue?vue&type=style&index=0&id=829a4bea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829a4bea",
  null
  
)

export default component.exports